import { render, staticRenderFns } from "./patientsInformation.vue?vue&type=template&id=228df84e&scoped=true&"
import script from "./patientsInformation.vue?vue&type=script&lang=js&"
export * from "./patientsInformation.vue?vue&type=script&lang=js&"
import style0 from "./patientsInformation.vue?vue&type=style&index=0&id=228df84e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228df84e",
  null
  
)

export default component.exports